import { render } from "./StatusArea.vue?vue&type=template&id=8c12e590&scoped=true"
import script from "./StatusArea.vue?vue&type=script&lang=js"
export * from "./StatusArea.vue?vue&type=script&lang=js"

import "./StatusArea.vue?vue&type=style&index=0&id=8c12e590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c12e590"]])

export default __exports__